export const authRoles = {
  sa: ['SA'],
  admin: ['SA', 'ADMIN','AGENT'],
  editor: ['SA', 'ADMIN', 'EDITOR','AGENT'],
  agent_lead: ['SA', 'ADMIN', 'AGENT'],
  guest: ['SA', 'ADMIN', 'EDITOR', 'GUEST','AGENT']
}